import React from 'react';
export const FormContext = React.createContext({
  editStatus: false
});
export const TableContext = React.createContext({
  toggle: () => null
});